function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M29 20L27.5306 13H7.93878L5 33H18.5",
  stroke: "black",
  strokeWidth: 3
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24 17C24 -3 12 -3 12 17",
  stroke: "black",
  strokeWidth: 2
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M36 28.2317C36 33.3657 31.6628 38 26.5 38C20.8352 38 17 33.4167 17 28.2317C17 23.1924 21.2433 19 26.5 19C31.7567 19 36 23.1924 36 28.2317Z",
  stroke: "black",
  strokeWidth: 3
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "number",
  d: "M27.5938 29.1514C27.097 29.598 26.541 29.8213 25.9258 29.8213C25.0234 29.8213 24.3079 29.516 23.7793 28.9053C23.2507 28.2946 22.9863 27.4788 22.9863 26.458C22.9863 25.82 23.1344 25.2275 23.4307 24.6807C23.7269 24.1338 24.1416 23.7008 24.6748 23.3818C25.2126 23.0628 25.805 22.9033 26.4521 22.9033C27.1084 22.9033 27.7008 23.0697 28.2295 23.4023C28.7627 23.7305 29.1774 24.1976 29.4736 24.8037C29.7699 25.4053 29.9225 26.1003 29.9316 26.8887V27.7705C29.9316 28.8688 29.7152 29.8213 29.2822 30.6279C28.8538 31.4346 28.2409 32.0544 27.4434 32.4873C26.6458 32.9202 25.7161 33.1367 24.6543 33.1367H24.5107V31.291L24.9482 31.2842C26.5342 31.2067 27.416 30.4958 27.5938 29.1514ZM26.5479 28.1602C27.0492 28.1602 27.4092 27.9437 27.6279 27.5107V26.5537C27.6279 25.9157 27.5208 25.444 27.3066 25.1387C27.0924 24.8333 26.8031 24.6807 26.4385 24.6807C26.1149 24.6807 25.8438 24.8538 25.625 25.2002C25.4062 25.5465 25.2969 25.9658 25.2969 26.458C25.2969 26.9775 25.4085 27.3923 25.6318 27.7021C25.8551 28.0075 26.1605 28.1602 26.5479 28.1602Z",
  fill: "black"
});

function SvgCart9(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart9);
export default __webpack_public_path__ + "static/media/cart9.2cb26fe9.svg";
export { ForwardRef as ReactComponent };